var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHemAinline = function SvgHemAinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.574 22.171a6.253 6.253 0 0 1-6.245-6.245c0-4.578 4.705-10.104 6.239-11.79.833.93 2.621 3.027 4.07 5.467l1.142-.677c-2.03-3.424-4.62-6.112-4.73-6.227a.658.658 0 0 0-.942 0C9.814 2.99 3 9.941 3 15.926 3 20.1 6.4 23.5 10.574 23.5a7.536 7.536 0 0 0 4.234-1.293l-.743-1.099a6.242 6.242 0 0 1-3.491 1.07v-.007Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.802 11.632-.502-.435c-.09.103-2.156 2.519-1.69 6.173l1.316-.17c-.387-3.043 1.359-5.109 1.377-5.133l-.501-.435Z",
    fill: "#4A4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.54 14.023h-2.302v-2.3a.383.383 0 0 0-.38-.381h-2.525a.383.383 0 0 0-.38.38v2.301h-2.301a.383.383 0 0 0-.381.38v2.525c0 .194.157.381.38.381h2.302v2.301c0 .193.157.38.38.38h2.525c.193 0 .38-.156.38-.38V17.31h2.301c.194 0 .38-.157.38-.38v-2.525c0-.193-.192-.38-.38-.38Z",
    fill: "#D9516C"
  })));
};
export default SvgHemAinline;